import React from "react";
import { App } from "antd";
import { setMessageApi } from "../Utilities/messageApi";

export const MessageBridge = () => {
  const { message, notification } = App.useApp();
  setMessageApi({ message, notification });
  return null;
};
